import {MessageSquare} from "react-feather";
import {CommentSection} from "../helper/interfaces";
import {CommentsItem} from "./CommentsDrawerNN";

interface CommentsNNProps {
  id: string;
  data: CommentSection
  onClick: () => void
}

const CommentsNN = ({id, data, onClick}: CommentsNNProps) => {
  const displayComments = (data && data.disableComments == false)
  const comment = data?.comments[0]
  const commentsCount = data?.commentsCount
  const commentsCountString = commentsCount > 1 ? `${commentsCount} Kommentare` : commentsCount === 1 ? '1 Kommentar' : 'Keine Kommentare'
  return (
    <>
    {displayComments && 
      <div id={id} className={`comments-nn ${comment ? 'comments-nn--has-comments' : ''}`}>
        <span className="comments-nn__line top" />
        <div className="comments-nn__info">
          <p className="comments-nn__count">{commentsCountString}</p>
          <CommentsItem text={comment?.text} author={comment?.author} creationDate={comment?.creationDate} />
          {comment &&
            <div className="comments-nn__footer">
              <button className="comments-nn__open btn btn-primary" onClick={onClick} disabled={!comment}>
                <MessageSquare />
                <div>Kommentare anzeigen</div>
              </button>
            </div>
          }
        </div>
        <span className="comments-nn__line bottom" />
      </div>
    }
    </>
    
  )
}

export default CommentsNN